<template>
	<div class="message-bubble product">
		<div v-for="(p, index) in product.messages" :key="index">
			<v-card class="product-container">
				<div class="image-container">
					<img
						:src="p.additionalParameters.images[0].full_url_image"
						v-if="p.additionalParameters.has_image"
					/>
				</div>
				<v-container>
					<p>{{ p.additionalParameters.description }}</p>
					<p><strong>Precio:</strong> ${{ p.additionalParameters.price }}</p>
					<div class="button-row">
						<v-btn
							class="button-rounding"
							outlined
							@click="minus"
						>
							<v-icon>mdi-minus</v-icon>
						</v-btn>
						<span class="text-center">
							{{ quantity }}
						</span>
						<v-btn
							class="button-rounding"
							outlined
							@click="add"
						>
							<v-icon>mdi-plus</v-icon>
						</v-btn>
					</div>
					<v-row>
						<v-col cols="12">
							<v-text-field
								small
								outlined
								color="var(--app-button)"
								hide-details="auto"
								label="Observaciones"
								v-model="observation"
							>
							</v-text-field>
						</v-col>
					</v-row>

					<v-row justify="space-between">
						<v-col cols="12" class="flex-wrap">
							<v-btn
								class="button-rounding"
								outlined
								@click="add_item_to_cart(p.additionalParameters)"
								small
							>
								<v-icon left>mdi-cart</v-icon>
								Agregar
							</v-btn>
							<v-btn
								class="button-rounding"
								outlined
								@click="go_to_banks(p.additionalParameters)"
								small
							>
								<v-icon left>mdi-credit-card</v-icon>
								Comprar
							</v-btn>
						</v-col>
					</v-row>
					<v-row no-gutters>
						<v-col cols="12">
							<BackBtn :return_to="'products'" :outlined="true" :block="true" />
						</v-col>
					</v-row>
				</v-container>
			</v-card>
		</div>
	</div>
</template>

<script>
import BackBtn from "./BackBtn";
export default {
	components: {
		BackBtn,
	},
	data: () => ({
		quantity: 1,
		observation: "",
	}),
	computed: {
		product: {
			get() {
				return this.$store.getters["chatStore/get_product"];
			},
		},
	},
	methods: {
		minus() {
			if (this.quantity > 1) {
				this.quantity--;
			}
		},
		add() {
			this.quantity++;
		},
		add_item_to_cart(product) {
			let item = product;
			item.qtt = this.quantity;
			item.quantity = this.quantity;
			item.type = "product";
			item.observation = this.observation;
			this.$store.dispatch("chatStore/add_to_cart", {
				data: item,
				type: "product",
			});
			this.go_to_extras(item.catalogue_id);
		},
		go_to_extras(catalogue_id, pushToCart = false) {
			let fd = new FormData();
			fd.append("message", "extras");
			fd.append("driver", "web");

			const data = {
				// id: this.$route.params.id,
				id: catalogue_id,
				data: fd,
				pushToCart
			};
			this.$store.dispatch("chatStore/get_extras", data, pushToCart);
		},
		async go_to_banks(product) {
			let item = product;
			item.qtt = this.quantity;
			item.quantity = this.quantity;
			item.type = "product";
			item.observation = this.observation;
			await this.$store.dispatch("chatStore/add_to_cart", {
				data: item,
				type: "product",
			});
			this.go_to_extras(item.catalogue_id, true);
		},
		see_more() {
			this.$store.commit("chatStore/STATUS", "products");
		},
	},
};
</script>

<style lang="scss" scope>
.product .row:not(.no-gutters){
	margin: 0;
	margin-left: -12px;
	margin-right: -12px;
}
.button-row {
	display: flex;
	align-items: center;
	justify-content: space-between;
}
.product-container {
	border-radius: 12px !important;
}
.product {
	.image-container {
		width: 100%;
		display: flex;
		justify-content: center;
		border-radius: 12px 12px 0px 0px;
		img {
			max-width: 100%;
			height: 248px;
			width: auto;
			margin: 0 auto;
			border-radius: 12px 12px 0px 0px;
		}
	}
}
.product-action {
	display: block !important;
}
.bot-product-image {
	height: 200px;
	width: auto;
}
.bot-product {
	width: min-content;
}
.bot-quantity {
	text-align: center;
}
@media (max-width: 360) {
	.bot-product {
		height: auto;
		width: 350px;
	}
}
.flex-wrap {
	display: flex;
	flex-wrap: wrap;
	justify-content: space-between;
	& > * {
		margin: 5px 0;
	}
}
</style>
